/**
 * @generated SignedSource<<fb2b71071733d1af37c1b69bbf396ca4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PinOption_unpinAnnouncement_Mutation$variables = {
  announcementId: string;
};
export type PinOption_unpinAnnouncement_Mutation$data = {
  readonly unpinAnnouncement: {
    readonly announcementUnpinned: {
      readonly id: string;
      readonly pinned: boolean;
    };
    readonly space: {
      readonly pinnedAnnouncements: {
        readonly __id: string;
        readonly " $fragmentSpreads": FragmentRefs<"AnnouncementsList_announcements">;
      } | null;
    };
  } | null;
};
export type PinOption_unpinAnnouncement_Mutation = {
  response: PinOption_unpinAnnouncement_Mutation$data;
  variables: PinOption_unpinAnnouncement_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "announcementId"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "announcementId",
        "variableName": "announcementId"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pinned",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Announcement",
  "kind": "LinkedField",
  "name": "announcementUnpinned",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v5 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 2
  },
  {
    "kind": "Literal",
    "name": "pinnedOnly",
    "value": true
  }
],
v6 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v10 = [
  (v8/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v10/*: any*/),
      "type": "NamedIcon",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "Color",
  "kind": "LinkedField",
  "name": "color",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "light",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dark",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v14 = [
  (v13/*: any*/)
],
v15 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "modules",
  "plural": true,
  "selections": [
    (v9/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AuthorizationResult",
          "kind": "LinkedField",
          "name": "canCreateAnnouncement",
          "plural": false,
          "selections": (v14/*: any*/),
          "storageKey": null
        }
      ],
      "type": "SpaceAnnouncementsModule",
      "abstractKey": null
    },
    (v2/*: any*/)
  ],
  "storageKey": null
},
v16 = [
  (v2/*: any*/)
],
v17 = [
  {
    "kind": "Literal",
    "name": "last",
    "value": 1
  }
],
v18 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Space",
      "kind": "LinkedField",
      "name": "ownershipSpace",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "AuthorizationResult",
          "kind": "LinkedField",
          "name": "canModifySpaceShortcuts",
          "plural": false,
          "selections": (v14/*: any*/),
          "storageKey": null
        },
        (v9/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Event",
      "kind": "LinkedField",
      "name": "ownershipEvent",
      "plural": false,
      "selections": (v16/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v17/*: any*/),
      "concreteType": "FolderConnection",
      "kind": "LinkedField",
      "name": "ownershipFolders",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Folder",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": (v16/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": "ownershipFolders(last:1)"
    }
  ],
  "type": "HasOwnerPermissionsInterface",
  "abstractKey": "__isHasOwnerPermissionsInterface"
},
v19 = {
  "alias": "announcementDate",
  "args": null,
  "kind": "ScalarField",
  "name": "publishedAt",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v22 = [
  (v21/*: any*/)
],
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "MemberAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": (v22/*: any*/),
  "storageKey": null
},
v24 = [
  (v2/*: any*/),
  (v8/*: any*/),
  (v20/*: any*/),
  (v23/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "roles",
    "storageKey": null
  }
],
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "Member",
  "kind": "LinkedField",
  "name": "announcer",
  "plural": false,
  "selections": (v24/*: any*/),
  "storageKey": null
},
v26 = {
  "kind": "InlineFragment",
  "selections": (v10/*: any*/),
  "type": "Event",
  "abstractKey": null
},
v27 = {
  "kind": "InlineFragment",
  "selections": (v10/*: any*/),
  "type": "Folder",
  "abstractKey": null
},
v28 = {
  "kind": "InlineFragment",
  "selections": (v10/*: any*/),
  "type": "FolderItem",
  "abstractKey": null
},
v29 = {
  "kind": "InlineFragment",
  "selections": (v16/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v30 = {
  "kind": "InlineFragment",
  "selections": (v16/*: any*/),
  "type": "PendingFile",
  "abstractKey": null
},
v31 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "content",
      "plural": false,
      "selections": [
        (v9/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": (v10/*: any*/),
          "type": "File",
          "abstractKey": null
        },
        (v29/*: any*/),
        (v30/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "AnnouncementAttachment",
  "abstractKey": null
},
v32 = {
  "alias": "canEdit",
  "args": null,
  "concreteType": "AuthorizationResult",
  "kind": "LinkedField",
  "name": "canUpdate",
  "plural": false,
  "selections": (v14/*: any*/),
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "AuthorizationResult",
  "kind": "LinkedField",
  "name": "canDelete",
  "plural": false,
  "selections": (v14/*: any*/),
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "AuthorizationResult",
  "kind": "LinkedField",
  "name": "canPin",
  "plural": false,
  "selections": (v14/*: any*/),
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "AuthorizationResult",
  "kind": "LinkedField",
  "name": "canUnpin",
  "plural": false,
  "selections": (v14/*: any*/),
  "storageKey": null
},
v36 = {
  "alias": "implementsPermissions",
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedAt",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v8/*: any*/),
    (v11/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": null
},
v39 = [
  (v2/*: any*/),
  (v8/*: any*/)
],
v40 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "ilSpace",
      "args": null,
      "concreteType": "Space",
      "kind": "LinkedField",
      "name": "ownershipSpace",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v8/*: any*/),
        (v12/*: any*/),
        (v11/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": "ilEvent",
      "args": null,
      "concreteType": "Event",
      "kind": "LinkedField",
      "name": "ownershipEvent",
      "plural": false,
      "selections": (v39/*: any*/),
      "storageKey": null
    },
    {
      "alias": "ilFolders",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        }
      ],
      "concreteType": "FolderConnection",
      "kind": "LinkedField",
      "name": "ownershipFolders",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Folder",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": (v39/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": "ownershipFolders(first:1)"
    }
  ],
  "type": "HasOwnerPermissionsInterface",
  "abstractKey": "__isHasOwnerPermissionsInterface"
},
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "Thumbnail",
  "kind": "LinkedField",
  "name": "thumbnail",
  "plural": false,
  "selections": (v22/*: any*/),
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mimeType",
  "storageKey": null
},
v43 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/),
    (v8/*: any*/),
    (v42/*: any*/),
    (v21/*: any*/)
  ],
  "type": "File",
  "abstractKey": null
},
v44 = {
  "kind": "InlineFragment",
  "selections": [
    (v41/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "content",
      "plural": false,
      "selections": [
        (v9/*: any*/),
        (v43/*: any*/),
        (v29/*: any*/),
        (v30/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "AnnouncementAttachment",
  "abstractKey": null
},
v45 = {
  "kind": "InlineFragment",
  "selections": [
    (v41/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "content",
      "plural": false,
      "selections": [
        (v9/*: any*/),
        (v43/*: any*/),
        (v29/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "MemberDetailsAttachment",
  "abstractKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastModifiedAt",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishState",
  "storageKey": null
},
v48 = {
  "alias": "announcementSpace",
  "args": null,
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v2/*: any*/),
    (v15/*: any*/)
  ],
  "storageKey": null
},
v49 = {
  "alias": "canUpdateThumbnail",
  "args": null,
  "concreteType": "AuthorizationResult",
  "kind": "LinkedField",
  "name": "canRename",
  "plural": false,
  "selections": (v14/*: any*/),
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "data",
  "storageKey": null
},
v52 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/),
    (v42/*: any*/),
    (v21/*: any*/)
  ],
  "type": "File",
  "abstractKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v54 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CustomField__FieldOption",
    "kind": "LinkedField",
    "name": "options",
    "plural": true,
    "selections": [
      (v13/*: any*/),
      (v53/*: any*/)
    ],
    "storageKey": null
  }
],
v55 = [
  (v2/*: any*/),
  (v21/*: any*/)
],
v56 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "content",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        (v51/*: any*/)
      ],
      "type": "Page",
      "abstractKey": null
    },
    (v52/*: any*/),
    (v30/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "FormQuestion",
          "kind": "LinkedField",
          "name": "questions",
          "plural": true,
          "selections": [
            (v2/*: any*/),
            (v53/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "required",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "definition",
              "plural": false,
              "selections": [
                (v9/*: any*/),
                (v2/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": (v54/*: any*/),
                  "type": "CustomField__Checkboxes",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "maxValue",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "minValue",
                      "storageKey": null
                    }
                  ],
                  "type": "CustomField__Numeric",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v54/*: any*/),
                  "type": "CustomField__MultipleChoice",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Form",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v55/*: any*/),
      "type": "ExternalBridge",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v55/*: any*/),
      "type": "InternalBridge",
      "abstractKey": null
    },
    (v29/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v22/*: any*/),
      "type": "BridgeInterface",
      "abstractKey": "__isBridgeInterface"
    }
  ],
  "storageKey": null
},
v57 = [
  (v9/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v42/*: any*/)
    ],
    "type": "File",
    "abstractKey": null
  },
  (v29/*: any*/),
  (v30/*: any*/)
],
v58 = {
  "alias": "folderItemContent",
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "content",
  "plural": false,
  "selections": (v57/*: any*/),
  "storageKey": null
},
v59 = {
  "alias": "canEdit",
  "args": null,
  "concreteType": "AuthorizationResult",
  "kind": "LinkedField",
  "name": "canRename",
  "plural": false,
  "selections": (v14/*: any*/),
  "storageKey": null
},
v60 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Pin",
      "kind": "LinkedField",
      "name": "pins",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "context",
          "storageKey": null
        },
        (v2/*: any*/),
        (v50/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "HasPinsInterface",
  "abstractKey": "__isHasPinsInterface"
},
v61 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SignatureEnvelope",
      "kind": "LinkedField",
      "name": "signatureEnvelope",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AuthorizationResult",
      "kind": "LinkedField",
      "name": "canCreateSignatureEnvelope",
      "plural": false,
      "selections": (v14/*: any*/),
      "storageKey": null
    }
  ],
  "type": "SignableInterface",
  "abstractKey": "__isSignableInterface"
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "utcDate",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "utcTime",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "concreteType": "VaultUploadGroup",
  "kind": "LinkedField",
  "name": "uploadGroup",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Member",
      "kind": "LinkedField",
      "name": "publisher",
      "plural": false,
      "selections": (v24/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DateTime",
      "kind": "LinkedField",
      "name": "publishedAt",
      "plural": false,
      "selections": [
        (v62/*: any*/),
        (v63/*: any*/)
      ],
      "storageKey": null
    },
    (v2/*: any*/)
  ],
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "content",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v52/*: any*/),
    (v30/*: any*/),
    (v29/*: any*/)
  ],
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cover",
  "storageKey": null
},
v67 = {
  "alias": "vaultItemContent",
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "content",
  "plural": false,
  "selections": (v57/*: any*/),
  "storageKey": null
},
v68 = {
  "alias": "isVaultItem",
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v69 = {
  "alias": "canSeeVaultItemPermissions",
  "args": null,
  "concreteType": "AuthorizationResult",
  "kind": "LinkedField",
  "name": "canDelete",
  "plural": false,
  "selections": (v14/*: any*/),
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "concreteType": "CoverImage",
  "kind": "LinkedField",
  "name": "coverImage",
  "plural": false,
  "selections": (v22/*: any*/),
  "storageKey": null
},
v71 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "date",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "time",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "timestamp",
    "storageKey": null
  },
  (v62/*: any*/),
  (v63/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "timezone",
    "storageKey": null
  }
],
v72 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Tag",
      "kind": "LinkedField",
      "name": "tags",
      "plural": true,
      "selections": (v16/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AuthorizationResult",
      "kind": "LinkedField",
      "name": "canUpdateTags",
      "plural": false,
      "selections": (v14/*: any*/),
      "storageKey": null
    }
  ],
  "type": "HasTagsInterface",
  "abstractKey": "__isHasTagsInterface"
},
v73 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isNew",
      "storageKey": null
    }
  ],
  "type": "IsNewInterface",
  "abstractKey": "__isIsNewInterface"
},
v74 = {
  "alias": null,
  "args": null,
  "concreteType": "AuthorizationResult",
  "kind": "LinkedField",
  "name": "canPublish",
  "plural": false,
  "selections": (v14/*: any*/),
  "storageKey": null
},
v75 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Space",
      "kind": "LinkedField",
      "name": "space",
      "plural": false,
      "selections": (v16/*: any*/),
      "storageKey": null
    }
  ],
  "type": "FolderItem",
  "abstractKey": null
},
v76 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MemberFavourite",
      "kind": "LinkedField",
      "name": "favourite",
      "plural": false,
      "selections": (v16/*: any*/),
      "storageKey": null
    }
  ],
  "type": "FavouritedInterface",
  "abstractKey": "__isFavouritedInterface"
},
v77 = {
  "alias": null,
  "args": null,
  "concreteType": "AuthorizationResult",
  "kind": "LinkedField",
  "name": "canUpdate",
  "plural": false,
  "selections": (v14/*: any*/),
  "storageKey": null
},
v78 = {
  "alias": "isVault",
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v79 = {
  "alias": "canUpdateThumbnail",
  "args": null,
  "concreteType": "AuthorizationResult",
  "kind": "LinkedField",
  "name": "canUpdate",
  "plural": false,
  "selections": (v14/*: any*/),
  "storageKey": null
},
v80 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AuthorizationResult",
      "kind": "LinkedField",
      "name": "canUpdateSecurity",
      "plural": false,
      "selections": (v14/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "preventDownload",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasWatermark",
      "storageKey": null
    }
  ],
  "type": "HasNodeSecurityInterface",
  "abstractKey": "__isHasNodeSecurityInterface"
},
v81 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "draftVaultItemContent",
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "content",
      "plural": false,
      "selections": (v57/*: any*/),
      "storageKey": null
    }
  ],
  "type": "VaultDraftItem",
  "abstractKey": null
},
v82 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canonicalUrl",
      "storageKey": null
    }
  ],
  "type": "HasCanonicalUrlInterface",
  "abstractKey": "__isHasCanonicalUrlInterface"
},
v83 = {
  "alias": null,
  "args": null,
  "concreteType": "AuthorizationResult",
  "kind": "LinkedField",
  "name": "canRename",
  "plural": false,
  "selections": (v14/*: any*/),
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "concreteType": "AuthorizationResult",
  "kind": "LinkedField",
  "name": "canMove",
  "plural": false,
  "selections": (v14/*: any*/),
  "storageKey": null
},
v85 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "FolderNodeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v16/*: any*/),
            "type": "Folder",
            "abstractKey": null
          },
          (v29/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v86 = {
  "alias": "root",
  "args": (v17/*: any*/),
  "concreteType": "FolderNodeConnection",
  "kind": "LinkedField",
  "name": "ancestors",
  "plural": false,
  "selections": (v85/*: any*/),
  "storageKey": "ancestors(last:1)"
},
v87 = {
  "alias": "parent",
  "args": [
    {
      "kind": "Literal",
      "name": "depth",
      "value": 1
    }
  ],
  "concreteType": "FolderNodeConnection",
  "kind": "LinkedField",
  "name": "ancestors",
  "plural": false,
  "selections": (v85/*: any*/),
  "storageKey": "ancestors(depth:1)"
},
v88 = {
  "kind": "InlineFragment",
  "selections": [
    (v41/*: any*/)
  ],
  "type": "HasThumbnailInterface",
  "abstractKey": "__isHasThumbnailInterface"
},
v89 = {
  "kind": "InlineFragment",
  "selections": [
    (v8/*: any*/),
    (v20/*: any*/),
    (v23/*: any*/)
  ],
  "type": "Member",
  "abstractKey": null
},
v90 = {
  "kind": "InlineFragment",
  "selections": [
    (v8/*: any*/),
    (v41/*: any*/),
    (v77/*: any*/),
    (v78/*: any*/),
    (v79/*: any*/)
  ],
  "type": "Vault",
  "abstractKey": null
},
v91 = {
  "kind": "InlineFragment",
  "selections": [
    (v8/*: any*/),
    (v47/*: any*/),
    (v33/*: any*/),
    (v83/*: any*/),
    (v84/*: any*/),
    (v86/*: any*/),
    (v87/*: any*/)
  ],
  "type": "FolderNodeInterface",
  "abstractKey": "__isFolderNodeInterface"
},
v92 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CustomField__FieldOption",
    "kind": "LinkedField",
    "name": "options",
    "plural": true,
    "selections": [
      (v53/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PinOption_unpinAnnouncement_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AnnouncementsUnpinMutationPayload",
        "kind": "LinkedField",
        "name": "unpinAnnouncement",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              {
                "alias": "pinnedAnnouncements",
                "args": (v5/*: any*/),
                "concreteType": "AnnouncementConnection",
                "kind": "LinkedField",
                "name": "announcements",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AnnouncementsList_announcements"
                  },
                  (v6/*: any*/)
                ],
                "storageKey": "announcements(first:2,pinnedOnly:true)"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PinOption_unpinAnnouncement_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AnnouncementsUnpinMutationPayload",
        "kind": "LinkedField",
        "name": "unpinAnnouncement",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              {
                "alias": "pinnedAnnouncements",
                "args": (v5/*: any*/),
                "concreteType": "AnnouncementConnection",
                "kind": "LinkedField",
                "name": "announcements",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AnnouncementEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Announcement",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v8/*: any*/),
                              (v11/*: any*/),
                              (v12/*: any*/),
                              (v15/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AnnouncementLinkConnection",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AnnouncementLink",
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "item",
                                    "plural": false,
                                    "selections": [
                                      (v9/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v2/*: any*/),
                                          (v18/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v19/*: any*/),
                                              (v25/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "AnnouncementLink",
                                                "kind": "LinkedField",
                                                "name": "link",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "item",
                                                    "plural": false,
                                                    "selections": [
                                                      (v9/*: any*/),
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          (v2/*: any*/),
                                                          (v26/*: any*/),
                                                          (v27/*: any*/),
                                                          (v28/*: any*/),
                                                          (v31/*: any*/)
                                                        ],
                                                        "type": "Node",
                                                        "abstractKey": "__isNode"
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  (v2/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v32/*: any*/),
                                              (v33/*: any*/),
                                              (v3/*: any*/),
                                              (v34/*: any*/),
                                              (v35/*: any*/),
                                              (v36/*: any*/),
                                              (v37/*: any*/),
                                              (v38/*: any*/),
                                              (v7/*: any*/),
                                              (v40/*: any*/)
                                            ],
                                            "type": "Announcement",
                                            "abstractKey": null
                                          },
                                          (v44/*: any*/),
                                          (v45/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v8/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Space",
                                                "kind": "LinkedField",
                                                "name": "space",
                                                "plural": false,
                                                "selections": [
                                                  (v2/*: any*/),
                                                  (v9/*: any*/),
                                                  (v15/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v37/*: any*/),
                                              (v46/*: any*/),
                                              (v41/*: any*/),
                                              (v47/*: any*/),
                                              (v48/*: any*/),
                                              (v36/*: any*/),
                                              (v49/*: any*/),
                                              (v40/*: any*/)
                                            ],
                                            "type": "Folder",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v8/*: any*/),
                                              (v50/*: any*/),
                                              (v37/*: any*/),
                                              (v46/*: any*/),
                                              (v56/*: any*/),
                                              (v41/*: any*/),
                                              (v58/*: any*/),
                                              (v47/*: any*/),
                                              (v48/*: any*/),
                                              (v59/*: any*/),
                                              (v36/*: any*/),
                                              (v60/*: any*/),
                                              (v40/*: any*/)
                                            ],
                                            "type": "FolderItem",
                                            "abstractKey": null
                                          },
                                          (v61/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v64/*: any*/),
                                              (v8/*: any*/),
                                              (v65/*: any*/),
                                              (v66/*: any*/),
                                              (v67/*: any*/),
                                              (v33/*: any*/),
                                              (v68/*: any*/),
                                              (v69/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Vault",
                                                "kind": "LinkedField",
                                                "name": "vault",
                                                "plural": false,
                                                "selections": (v39/*: any*/),
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "VaultItem",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v8/*: any*/),
                                              (v47/*: any*/),
                                              (v48/*: any*/),
                                              (v70/*: any*/),
                                              (v33/*: any*/),
                                              (v32/*: any*/),
                                              (v38/*: any*/),
                                              (v36/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "DateTime",
                                                "kind": "LinkedField",
                                                "name": "start",
                                                "plural": false,
                                                "selections": (v71/*: any*/),
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "DateTime",
                                                "kind": "LinkedField",
                                                "name": "end",
                                                "plural": false,
                                                "selections": (v71/*: any*/),
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "allDay",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "EventInvitation",
                                                "kind": "LinkedField",
                                                "name": "currentInvitation",
                                                "plural": false,
                                                "selections": [
                                                  (v2/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "rsvp",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Member",
                                                    "kind": "LinkedField",
                                                    "name": "invitee",
                                                    "plural": false,
                                                    "selections": (v16/*: any*/),
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "EventInvitationConnection",
                                                "kind": "LinkedField",
                                                "name": "invitations",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "count",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": "attendingCount",
                                                    "args": [
                                                      {
                                                        "kind": "Literal",
                                                        "name": "rsvpState",
                                                        "value": "ATTENDING"
                                                      }
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "count",
                                                    "storageKey": "count(rsvpState:\"ATTENDING\")"
                                                  }
                                                ],
                                                "storageKey": null
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v72/*: any*/),
                                                  (v73/*: any*/),
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          (v74/*: any*/),
                                                          (v75/*: any*/)
                                                        ],
                                                        "type": "FolderNodeInterface",
                                                        "abstractKey": "__isFolderNodeInterface"
                                                      }
                                                    ],
                                                    "type": "FolderNode",
                                                    "abstractKey": "__isFolderNode"
                                                  },
                                                  (v76/*: any*/),
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      (v20/*: any*/),
                                                      (v23/*: any*/)
                                                    ],
                                                    "type": "Member",
                                                    "abstractKey": null
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      (v41/*: any*/),
                                                      (v77/*: any*/),
                                                      (v78/*: any*/),
                                                      (v79/*: any*/)
                                                    ],
                                                    "type": "Vault",
                                                    "abstractKey": null
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      (v12/*: any*/)
                                                    ],
                                                    "type": "Space",
                                                    "abstractKey": null
                                                  },
                                                  (v80/*: any*/),
                                                  (v81/*: any*/),
                                                  (v82/*: any*/),
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      (v83/*: any*/),
                                                      (v84/*: any*/),
                                                      (v86/*: any*/),
                                                      (v87/*: any*/)
                                                    ],
                                                    "type": "FolderNodeInterface",
                                                    "abstractKey": "__isFolderNodeInterface"
                                                  },
                                                  (v88/*: any*/),
                                                  (v60/*: any*/)
                                                ],
                                                "type": "Node",
                                                "abstractKey": "__isNode"
                                              },
                                              (v40/*: any*/)
                                            ],
                                            "type": "Event",
                                            "abstractKey": null
                                          },
                                          (v89/*: any*/),
                                          (v90/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v8/*: any*/),
                                              (v12/*: any*/),
                                              (v11/*: any*/)
                                            ],
                                            "type": "Space",
                                            "abstractKey": null
                                          },
                                          (v72/*: any*/),
                                          (v73/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v74/*: any*/),
                                                  (v47/*: any*/),
                                                  (v75/*: any*/)
                                                ],
                                                "type": "FolderNodeInterface",
                                                "abstractKey": "__isFolderNodeInterface"
                                              }
                                            ],
                                            "type": "FolderNode",
                                            "abstractKey": "__isFolderNode"
                                          },
                                          (v76/*: any*/),
                                          (v80/*: any*/),
                                          (v81/*: any*/),
                                          (v82/*: any*/),
                                          (v91/*: any*/),
                                          (v88/*: any*/),
                                          (v60/*: any*/)
                                        ],
                                        "type": "Node",
                                        "abstractKey": "__isNode"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v16/*: any*/),
                                        "type": "FolderItem",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v2/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "content",
                                            "plural": false,
                                            "selections": [
                                              (v9/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "fileName",
                                                    "storageKey": null
                                                  },
                                                  (v42/*: any*/),
                                                  (v21/*: any*/)
                                                ],
                                                "type": "File",
                                                "abstractKey": null
                                              },
                                              (v29/*: any*/),
                                              (v30/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "AnnouncementAttachment",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v25/*: any*/),
                          (v37/*: any*/),
                          (v3/*: any*/),
                          (v35/*: any*/),
                          (v34/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AnnouncementLink",
                            "kind": "LinkedField",
                            "name": "link",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "item",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  (v29/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lastEditedAt",
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v9/*: any*/),
                              (v72/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v66/*: any*/),
                                  (v64/*: any*/),
                                  (v8/*: any*/),
                                  (v65/*: any*/),
                                  (v67/*: any*/),
                                  (v33/*: any*/),
                                  (v68/*: any*/),
                                  (v69/*: any*/)
                                ],
                                "type": "VaultItem",
                                "abstractKey": null
                              },
                              (v73/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v74/*: any*/),
                                      (v47/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "content",
                                            "plural": false,
                                            "selections": [
                                              (v9/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v2/*: any*/),
                                                  (v51/*: any*/)
                                                ],
                                                "type": "Page",
                                                "abstractKey": null
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v2/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "FormQuestion",
                                                    "kind": "LinkedField",
                                                    "name": "questions",
                                                    "plural": true,
                                                    "selections": [
                                                      (v2/*: any*/),
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": null,
                                                        "kind": "LinkedField",
                                                        "name": "definition",
                                                        "plural": false,
                                                        "selections": [
                                                          (v9/*: any*/),
                                                          (v2/*: any*/),
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": (v92/*: any*/),
                                                            "type": "CustomField__Checkboxes",
                                                            "abstractKey": null
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": (v92/*: any*/),
                                                            "type": "CustomField__MultipleChoice",
                                                            "abstractKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "type": "Form",
                                                "abstractKey": null
                                              },
                                              (v29/*: any*/),
                                              (v30/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v8/*: any*/)
                                        ],
                                        "type": "FolderItem",
                                        "abstractKey": null
                                      }
                                    ],
                                    "type": "FolderNodeInterface",
                                    "abstractKey": "__isFolderNodeInterface"
                                  }
                                ],
                                "type": "FolderNode",
                                "abstractKey": "__isFolderNode"
                              },
                              (v76/*: any*/),
                              (v18/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v19/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AnnouncementLink",
                                    "kind": "LinkedField",
                                    "name": "link",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "item",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v26/*: any*/),
                                              (v27/*: any*/),
                                              (v28/*: any*/),
                                              (v31/*: any*/)
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v32/*: any*/),
                                  (v33/*: any*/),
                                  (v36/*: any*/)
                                ],
                                "type": "Announcement",
                                "abstractKey": null
                              },
                              (v44/*: any*/),
                              (v45/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v8/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "space",
                                    "plural": false,
                                    "selections": [
                                      (v9/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v46/*: any*/),
                                  (v41/*: any*/),
                                  (v47/*: any*/),
                                  (v48/*: any*/),
                                  (v36/*: any*/),
                                  (v49/*: any*/)
                                ],
                                "type": "Folder",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v8/*: any*/),
                                  (v50/*: any*/),
                                  (v46/*: any*/),
                                  (v56/*: any*/),
                                  (v41/*: any*/),
                                  (v58/*: any*/),
                                  (v47/*: any*/),
                                  (v48/*: any*/),
                                  (v59/*: any*/),
                                  (v36/*: any*/),
                                  (v60/*: any*/)
                                ],
                                "type": "FolderItem",
                                "abstractKey": null
                              },
                              (v61/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v8/*: any*/),
                                  (v47/*: any*/),
                                  (v48/*: any*/),
                                  (v70/*: any*/),
                                  (v33/*: any*/),
                                  (v32/*: any*/),
                                  (v36/*: any*/)
                                ],
                                "type": "Event",
                                "abstractKey": null
                              },
                              (v89/*: any*/),
                              (v90/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v8/*: any*/),
                                  (v12/*: any*/)
                                ],
                                "type": "Space",
                                "abstractKey": null
                              },
                              (v80/*: any*/),
                              (v81/*: any*/),
                              (v82/*: any*/),
                              (v91/*: any*/),
                              (v88/*: any*/),
                              (v60/*: any*/)
                            ],
                            "type": "Node",
                            "abstractKey": "__isNode"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": "announcements(first:2,pinnedOnly:true)"
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b7591d8137a2b4501f650e676f1f8184",
    "id": null,
    "metadata": {},
    "name": "PinOption_unpinAnnouncement_Mutation",
    "operationKind": "mutation",
    "text": "mutation PinOption_unpinAnnouncement_Mutation(\n  $announcementId: ID!\n) {\n  unpinAnnouncement(input: {announcementId: $announcementId}) {\n    announcementUnpinned {\n      id\n      pinned\n    }\n    space {\n      pinnedAnnouncements: announcements(pinnedOnly: true, first: 2) {\n        ...AnnouncementsList_announcements\n      }\n      id\n    }\n  }\n}\n\nfragment AccessOption_node on Node {\n  __isNode: __typename\n  id\n  ... on Event {\n    implementsPermissions: __typename\n  }\n  ... on FolderItem {\n    implementsPermissions: __typename\n  }\n  ... on Folder {\n    implementsPermissions: __typename\n  }\n  ... on Announcement {\n    implementsPermissions: __typename\n  }\n  ... on VaultItem {\n    isVaultItem: __typename\n    canSeeVaultItemPermissions: canDelete {\n      value\n    }\n  }\n  ... on Vault {\n    isVault: __typename\n  }\n}\n\nfragment AnnounceOption_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on Folder {\n    space {\n      __typename\n      id\n      modules {\n        __typename\n        ... on SpaceAnnouncementsModule {\n          canCreateAnnouncement {\n            value\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment AnnouncementAttachmentCard_details on AnnouncementAttachment {\n  id\n  thumbnail {\n    url\n  }\n  content {\n    __typename\n    ... on File {\n      __typename\n      name\n      mimeType\n      url\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on PendingFile {\n      id\n    }\n  }\n}\n\nfragment AnnouncementButton_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on Folder {\n    publishState\n    announcementSpace: space {\n      __typename\n      id\n      modules {\n        __typename\n        ... on SpaceAnnouncementsModule {\n          canCreateAnnouncement {\n            value\n          }\n        }\n        id\n      }\n    }\n  }\n  ... on FolderItem {\n    publishState\n    announcementSpace: space {\n      __typename\n      id\n      modules {\n        __typename\n        ... on SpaceAnnouncementsModule {\n          canCreateAnnouncement {\n            value\n          }\n        }\n        id\n      }\n    }\n  }\n  ... on Event {\n    publishState\n    announcementSpace: space {\n      __typename\n      id\n      modules {\n        __typename\n        ... on SpaceAnnouncementsModule {\n          canCreateAnnouncement {\n            value\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment AnnouncementCard_announcement on Announcement {\n  id\n  message\n  space {\n    id\n    ...SpaceContextCard_space\n  }\n  links {\n    nodes {\n      id\n      item {\n        __typename\n        ...ItemCard_item\n        ...ItemCardSmall\n        ... on FolderItem {\n          id\n        }\n        ... on AnnouncementAttachment {\n          id\n          content {\n            __typename\n            ... on File {\n              fileName\n              mimeType\n              url\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n            ... on PendingFile {\n              id\n            }\n          }\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n  ...AnnouncementMetadata_announcement\n}\n\nfragment AnnouncementMetadata_announcement on Announcement {\n  id\n  ... on Node {\n    __isNode: __typename\n    ...ItemMenu_node\n    ...PinOption_node\n  }\n  message\n  announcer {\n    id\n    name\n    ...UserHandle_member\n  }\n  publishedAt\n  pinned\n  canUnpin {\n    value\n  }\n  canPin {\n    value\n  }\n  space {\n    modules {\n      __typename\n      ... on SpaceAnnouncementsModule {\n        canCreateAnnouncement {\n          value\n        }\n      }\n      id\n    }\n    id\n  }\n  link {\n    item {\n      __typename\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    id\n  }\n  lastEditedAt\n}\n\nfragment AnnouncementsList_announcements on AnnouncementConnection {\n  edges {\n    node {\n      id\n      ...AnnouncementCard_announcement\n    }\n  }\n}\n\nfragment CopyLinkButton_node on Node {\n  __isNode: __typename\n  ... on HasCanonicalUrlInterface {\n    __isHasCanonicalUrlInterface: __typename\n    canonicalUrl\n  }\n}\n\nfragment CreateShortcutOption_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on HasOwnerPermissionsInterface {\n    __isHasOwnerPermissionsInterface: __typename\n    ownershipSpace {\n      id\n      canModifySpaceShortcuts {\n        value\n      }\n      ...ManageSpaceShortcutModal_space\n    }\n    ownershipEvent {\n      id\n    }\n    ownershipFolders(last: 1) {\n      nodes {\n        id\n      }\n    }\n  }\n  ... on HasThumbnailInterface {\n    __isHasThumbnailInterface: __typename\n    thumbnail {\n      url\n    }\n  }\n  ... on FolderNodeInterface {\n    __isFolderNodeInterface: __typename\n    name\n    publishState\n  }\n  ... on FolderItem {\n    content {\n      __typename\n      ... on File {\n        id\n        url\n        mimeType\n      }\n      ... on BridgeInterface {\n        __isBridgeInterface: __typename\n        url\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n  ... on Event {\n    name\n    publishState\n    coverImage {\n      url\n    }\n  }\n}\n\nfragment DateTimeLabel_event on Event {\n  id\n  start {\n    date\n    time\n    timestamp\n    utcDate\n    utcTime\n    timezone\n  }\n  end {\n    date\n    time\n    timestamp\n    utcDate\n    utcTime\n    timezone\n  }\n  allDay\n}\n\nfragment DeleteNodeOption_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on FolderNodeInterface {\n    __isFolderNodeInterface: __typename\n    canDelete {\n      value\n    }\n    name\n  }\n  ... on HasOwnerPermissionsInterface {\n    __isHasOwnerPermissionsInterface: __typename\n    ownershipEvent {\n      id\n    }\n  }\n  ... on Event {\n    name\n    canDelete {\n      value\n    }\n    space {\n      id\n    }\n  }\n  ... on Announcement {\n    canDelete {\n      value\n    }\n  }\n  ... on VaultItem {\n    canDelete {\n      value\n    }\n  }\n}\n\nfragment DownloadButton_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ...useItemHandleFragment\n  ...useNodeSecurity_node\n  ... on FolderItem {\n    content {\n      __typename\n      ... on File {\n        id\n        url\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n  ... on VaultItem {\n    content {\n      __typename\n      ... on File {\n        url\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n}\n\nfragment DuplicateOption_node on Node {\n  __isNode: __typename\n  __typename\n  ... on FolderNodeInterface {\n    __isFolderNodeInterface: __typename\n    parent: ancestors(depth: 1) {\n      edges {\n        node {\n          __typename\n          ... on Folder {\n            id\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n  }\n  ... on FolderItem {\n    id\n    name\n    content {\n      __typename\n      ... on Form {\n        id\n        questions {\n          id\n          text\n          required\n          definition {\n            __typename\n            id\n            ... on CustomField__Checkboxes {\n              options {\n                value\n                text\n              }\n            }\n            ... on CustomField__Numeric {\n              maxValue\n              minValue\n            }\n            ... on CustomField__MultipleChoice {\n              options {\n                value\n                text\n              }\n            }\n          }\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n}\n\nfragment EditOption_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on Announcement {\n    canEdit: canUpdate {\n      value\n    }\n  }\n  ... on Event {\n    canEdit: canUpdate {\n      value\n    }\n  }\n  ... on FolderItem {\n    canEdit: canRename {\n      value\n    }\n    content {\n      __typename\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n}\n\nfragment EditableFolderItemMenu_folderItemNode on FolderNodeInterface {\n  __isFolderNodeInterface: __typename\n  __typename\n  canPublish {\n    value\n  }\n  publishState\n  ... on FolderItem {\n    id\n    content {\n      __typename\n      ... on Page {\n        id\n        data\n      }\n      ... on Form {\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n    ...PublishFolderItemDialog_folderItem\n  }\n}\n\nfragment EventCard_event on Event {\n  id\n  ...DateTimeLabel_event\n  name\n  space {\n    ...SpaceContextCard_space\n    color {\n      light\n      dark\n    }\n    id\n  }\n  start {\n    date\n  }\n  end {\n    date\n    time\n  }\n  currentInvitation {\n    id\n    rsvp\n    invitee {\n      id\n    }\n  }\n  ...InviteeOverview\n  coverImage {\n    url\n  }\n  ... on Node {\n    __isNode: __typename\n    ...ItemMenu_node\n  }\n}\n\nfragment FavouriteButton_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on FavouritedInterface {\n    __isFavouritedInterface: __typename\n    favourite {\n      id\n    }\n  }\n}\n\nfragment InviteeOverview on Event {\n  invitations {\n    count\n    attendingCount: count(rsvpState: ATTENDING)\n  }\n}\n\nfragment ItemCardSmall on Node {\n  __isNode: __typename\n  id\n  __typename\n  ... on AnnouncementAttachment {\n    content {\n      __typename\n      ... on File {\n        name\n        mimeType\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n  ... on Member {\n    name\n    ...UserAvatar_member\n  }\n  ... on Space {\n    name\n    icon {\n      __typename\n      ... on NamedIcon {\n        name\n      }\n    }\n    color {\n      light\n      dark\n    }\n  }\n  ... on Event {\n    name\n    ...ItemLocationInfo_item\n  }\n  ... on Folder {\n    name\n    ...ItemLocationInfo_item\n  }\n  ... on FolderItem {\n    name\n    content {\n      __typename\n      ... on File {\n        mimeType\n      }\n      ... on Page {\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n    ...ItemLocationInfo_item\n  }\n  ... on VaultItem {\n    name\n    content {\n      __typename\n      ... on File {\n        mimeType\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n    vault {\n      id\n      name\n    }\n  }\n  ... on Announcement {\n    announcer {\n      name\n      id\n    }\n    space {\n      id\n    }\n    publishedAt\n    message\n    ...ItemLocationInfo_item\n  }\n}\n\nfragment ItemCard_item on Node {\n  __isNode: __typename\n  id\n  __typename\n  ...useItemHandleFragment\n  ...ItemMenu_node\n  ... on Event {\n    name\n    ...EventCard_event\n  }\n  ... on Folder {\n    name\n  }\n  ... on FolderItem {\n    name\n    content {\n      __typename\n      ... on File {\n        mimeType\n      }\n      ... on Page {\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n  ... on Space {\n    ...SpaceCard_space\n  }\n  ... on Announcement {\n    ...MinimalAnnouncementCard_announcement\n  }\n  ... on AnnouncementAttachment {\n    ...AnnouncementAttachmentCard_details\n  }\n}\n\nfragment ItemLocationInfo_item on HasOwnerPermissionsInterface {\n  __isHasOwnerPermissionsInterface: __typename\n  ilSpace: ownershipSpace {\n    id\n    name\n    color {\n      light\n      dark\n    }\n    icon {\n      __typename\n      ... on NamedIcon {\n        name\n      }\n    }\n  }\n  ilEvent: ownershipEvent {\n    id\n    name\n  }\n  ilFolders: ownershipFolders(first: 1) {\n    nodes {\n      id\n      name\n    }\n  }\n}\n\nfragment ItemMenu_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ...TagButton_node\n  ...TagsButton_node\n  ...Status_node\n  ...FavouriteButton_node\n  ...DownloadButton_node\n  ...ShareButton_node\n  ...EditOption_node\n  ...RenameOption_node\n  ...MoveOption_node\n  ...DeleteNodeOption_node\n  ...PinOption_node\n  ...DuplicateOption_node\n  ...AnnounceOption_node\n  ...CreateShortcutOption_node\n  ...AccessOption_node\n  ...ManageVaultFieldsOption_node\n  ...RequestSignaturesOption_node\n  ...ThumbnailOption_node\n  ...MarkAsOption_node\n}\n\nfragment ManageSpaceShortcutModal_space on Space {\n  __typename\n  id\n}\n\nfragment ManageVaultFieldsOption_node on Node {\n  __isNode: __typename\n  id\n  ... on Vault {\n    __typename\n    canUpdate {\n      value\n    }\n  }\n}\n\nfragment MarkAsOption_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on HasPinsInterface {\n    __isHasPinsInterface: __typename\n    pins {\n      context\n      id\n      label\n    }\n  }\n  ... on HasOwnerPermissionsInterface {\n    __isHasOwnerPermissionsInterface: __typename\n    ownershipEvent {\n      id\n    }\n  }\n}\n\nfragment MinimalAnnouncementCard_announcement on Announcement {\n  id\n  publishedAt\n  space {\n    id\n    ...SpaceIndicator_space\n  }\n  announcer {\n    ...UserHandle_member\n    id\n  }\n}\n\nfragment MoveOption_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on FolderNodeInterface {\n    __isFolderNodeInterface: __typename\n    canMove {\n      value\n    }\n    root: ancestors(last: 1) {\n      edges {\n        node {\n          __typename\n          ... on Folder {\n            id\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment PinOption_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on Announcement {\n    pinned\n    canPin {\n      value\n    }\n    canUnpin {\n      value\n    }\n  }\n}\n\nfragment PublishFolderItemDialog_folderItem on FolderItem {\n  id\n  name\n  content {\n    __typename\n    ... on Page {\n      id\n      data\n    }\n    ... on Form {\n      id\n      questions {\n        id\n        definition {\n          __typename\n          id\n          ... on CustomField__Checkboxes {\n            options {\n              text\n            }\n          }\n          ... on CustomField__MultipleChoice {\n            options {\n              text\n            }\n          }\n        }\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on PendingFile {\n      id\n    }\n  }\n  space {\n    id\n  }\n}\n\nfragment ReminderButton_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on FolderNodeInterface {\n    __isFolderNodeInterface: __typename\n    publishState\n    canDelete {\n      value\n    }\n  }\n  ... on FolderItem {\n    content {\n      __typename\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n  ... on VaultItem {\n    canDelete {\n      value\n    }\n    content {\n      __typename\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n  ... on Event {\n    publishState\n    canDelete {\n      value\n    }\n  }\n}\n\nfragment RenameOption_node on Node {\n  __isNode: __typename\n  id\n  ... on FolderNodeInterface {\n    __isFolderNodeInterface: __typename\n    __typename\n    name\n    canRename {\n      value\n    }\n  }\n  ... on Vault {\n    __typename\n    name\n    canUpdate {\n      value\n    }\n  }\n}\n\nfragment RequestSignaturesOption_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on SignableInterface {\n    __isSignableInterface: __typename\n    canCreateSignatureEnvelope {\n      value\n    }\n    signatureEnvelope {\n      id\n      status\n    }\n  }\n}\n\nfragment ShareButton_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ...CopyLinkButton_node\n  ...WebShareButton_node\n  ...DownloadButton_node\n  ...AnnouncementButton_node\n  ...ShortcutButton_node\n  ...ReminderButton_node\n}\n\nfragment ShortcutButton_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on HasOwnerPermissionsInterface {\n    __isHasOwnerPermissionsInterface: __typename\n    ownershipSpace {\n      id\n      canModifySpaceShortcuts {\n        value\n      }\n      ...ManageSpaceShortcutModal_space\n    }\n    ownershipEvent {\n      id\n    }\n    ownershipFolders(last: 1) {\n      nodes {\n        id\n      }\n    }\n  }\n  ... on FolderNodeInterface {\n    __isFolderNodeInterface: __typename\n    name\n    publishState\n  }\n  ... on FolderItem {\n    content {\n      __typename\n      ... on File {\n        id\n        url\n        mimeType\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n  ... on Event {\n    name\n    publishState\n    coverImage {\n      url\n    }\n  }\n}\n\nfragment SpaceCard_space on Space {\n  id\n  name\n  color {\n    light\n    dark\n  }\n  icon {\n    __typename\n    ... on NamedIcon {\n      name\n    }\n  }\n}\n\nfragment SpaceContextCard_space on Space {\n  id\n  ...SpaceIndicator_space\n  color {\n    light\n    dark\n  }\n}\n\nfragment SpaceIndicator_space on Space {\n  id\n  name\n  icon {\n    __typename\n    ... on NamedIcon {\n      name\n    }\n  }\n  color {\n    light\n    dark\n  }\n}\n\nfragment Status_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on VaultItem {\n    cover\n  }\n  ... on IsNewInterface {\n    __isIsNewInterface: __typename\n    isNew\n  }\n  ... on FolderNode {\n    __isFolderNode: __typename\n    ...EditableFolderItemMenu_folderItemNode\n  }\n}\n\nfragment TagButton_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on HasTagsInterface {\n    __isHasTagsInterface: __typename\n    tags {\n      id\n    }\n    canUpdateTags {\n      value\n    }\n  }\n}\n\nfragment TagsButton_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on HasTagsInterface {\n    __isHasTagsInterface: __typename\n    tags {\n      id\n    }\n  }\n  ...TagButton_node\n}\n\nfragment ThumbnailOption_node on Node {\n  __isNode: __typename\n  id\n  ... on Folder {\n    canUpdateThumbnail: canRename {\n      value\n    }\n  }\n  ... on Vault {\n    canUpdateThumbnail: canUpdate {\n      value\n    }\n  }\n  ... on HasThumbnailInterface {\n    __isHasThumbnailInterface: __typename\n    __typename\n    thumbnail {\n      url\n    }\n  }\n}\n\nfragment UserAvatar_member on Member {\n  name\n  email\n  avatar {\n    url\n  }\n}\n\nfragment UserHandle_member on Member {\n  id\n  name\n  email\n  ...UserAvatar_member\n  ...UserInfoPopover_member\n}\n\nfragment UserInfoPopover_member on Member {\n  id\n  name\n  email\n  roles\n  ...UserAvatar_member\n}\n\nfragment VaultItemAccessDetails_node on VaultItem {\n  id\n  uploadGroup {\n    publisher {\n      id\n      ...UserHandle_member\n    }\n    publishedAt {\n      utcDate\n      utcTime\n    }\n    id\n  }\n}\n\nfragment WebShareButton_node on Node {\n  __isNode: __typename\n  ... on HasCanonicalUrlInterface {\n    __isHasCanonicalUrlInterface: __typename\n    canonicalUrl\n  }\n  ... on FolderNodeInterface {\n    __isFolderNodeInterface: __typename\n    __typename\n    name\n  }\n  ... on Event {\n    __typename\n    name\n  }\n  ... on Vault {\n    __typename\n    name\n  }\n  ... on VaultItem {\n    __typename\n    name\n  }\n  ... on Space {\n    __typename\n    name\n  }\n  ... on Announcement {\n    __typename\n  }\n}\n\nfragment useItemHandleFragment on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on HasOwnerPermissionsInterface {\n    __isHasOwnerPermissionsInterface: __typename\n    ownershipSpace {\n      id\n    }\n    ownershipEvent {\n      id\n    }\n    ownershipFolders(last: 1) {\n      nodes {\n        id\n      }\n    }\n  }\n  ... on Announcement {\n    announcementDate: publishedAt\n    announcer {\n      id\n      name\n    }\n    link {\n      item {\n        __typename\n        ... on Node {\n          __isNode: __typename\n          id\n          ... on Event {\n            name\n          }\n          ... on Folder {\n            name\n          }\n          ... on FolderItem {\n            name\n          }\n          ... on AnnouncementAttachment {\n            content {\n              __typename\n              ... on File {\n                name\n              }\n              ... on Node {\n                __isNode: __typename\n                id\n              }\n              ... on PendingFile {\n                id\n              }\n            }\n          }\n        }\n      }\n      id\n    }\n  }\n  ... on AnnouncementAttachment {\n    thumbnail {\n      url\n    }\n    content {\n      __typename\n      ... on File {\n        id\n        name\n        mimeType\n        url\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n  ... on MemberDetailsAttachment {\n    thumbnail {\n      url\n    }\n    content {\n      __typename\n      ... on File {\n        id\n        name\n        mimeType\n        url\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ... on Folder {\n    name\n    space {\n      id\n    }\n    publishedAt\n    lastModifiedAt\n    thumbnail {\n      url\n    }\n  }\n  ... on FolderItem {\n    name\n    label\n    publishedAt\n    lastModifiedAt\n    content {\n      __typename\n      ... on Page {\n        id\n        title\n        data\n      }\n      ... on File {\n        id\n        mimeType\n        url\n      }\n      ... on PendingFile {\n        id\n      }\n      ... on Form {\n        id\n        questions {\n          id\n          text\n        }\n      }\n      ... on ExternalBridge {\n        id\n        url\n      }\n      ... on InternalBridge {\n        id\n        url\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    thumbnail {\n      url\n    }\n    ... on HasPinsInterface {\n      __isHasPinsInterface: __typename\n      pins {\n        context\n        id\n        label\n      }\n    }\n  }\n  ... on SignableInterface {\n    __isSignableInterface: __typename\n    signatureEnvelope {\n      id\n      status\n    }\n  }\n  ... on VaultItem {\n    ...VaultItemAccessDetails_node\n    name\n    uploadGroup {\n      publishedAt {\n        utcDate\n        utcTime\n      }\n      publisher {\n        name\n        id\n      }\n      id\n    }\n    content {\n      __typename\n      ... on File {\n        id\n        mimeType\n        url\n      }\n      ... on PendingFile {\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ... on Event {\n    name\n  }\n  ... on Member {\n    name\n    ...UserAvatar_member\n  }\n  ... on Vault {\n    name\n    thumbnail {\n      url\n    }\n  }\n  ... on Space {\n    name\n    color {\n      light\n      dark\n    }\n  }\n}\n\nfragment useNodeSecurity_node on Node {\n  __isNode: __typename\n  id\n  ... on HasNodeSecurityInterface {\n    __isHasNodeSecurityInterface: __typename\n    canUpdateSecurity {\n      value\n    }\n    preventDownload\n    hasWatermark\n  }\n  ... on FolderItem {\n    folderItemContent: content {\n      __typename\n      ... on File {\n        mimeType\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n  ... on VaultItem {\n    vaultItemContent: content {\n      __typename\n      ... on File {\n        mimeType\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n  ... on VaultDraftItem {\n    draftVaultItemContent: content {\n      __typename\n      ... on File {\n        mimeType\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "71b89dc95ba18a30f69de1f7d1575134";

export default node;
